(function () {
  'use strict';

  angular.module('app').component('measurementUnitDetail', measurementUnitDetail());

  function measurementUnitDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onMeasurementUnitSaved: '&',
        onMeasurementUnitCanceled: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: MeasurementUnitDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/measurement-units/measurement-unit-detail/measurement-unit-detail.component.html',
    };
  }

  MeasurementUnitDetailComponent.$inject = ['UtilService', 'MeasurementUnitService'];

  function MeasurementUnitDetailComponent(UtilService, MeasurementUnitService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.checkedProductTypes = [];

    // Methods
    vm.editMeasurementUnit = editMeasurementUnit;
    vm.cancelEdit = cancelEdit;
    vm.openTranslations = openTranslations;
    vm.checkProductType = checkProductType;
    vm.saveMeasurementUnit = saveMeasurementUnit;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          symbol: 'Otros',
          allow_decimals: false,
          is_a_service: false,
          increment_value: 1,
        };
      }

      // Initializers
      getProductTypes();
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editMeasurementUnit();
      }

      setCheckedProductTypes(vm.item.product_types);

      vm.originalItem = angular.copy(item); // store server data
    }

    function editMeasurementUnit() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function getProductTypes() {
      vm.productTypes = vm.UtilService.getProductTypes();
    }

    function openTranslations() {
      MeasurementUnitService.openMeasurementUnitTranslations(vm.item, vm.additionalLanguages);
    }

    function setCheckedProductTypes(productTypes) {
      vm.isCheckedProductTypes = productTypes.length > 0 ? true : false;

      productTypes.forEach(function (productType) {
        vm.checkedProductTypes[productType] = true;
      });
    }

    function checkProductType() {
      vm.isCheckedProductTypes = Object.keys(vm.checkedProductTypes).some(function (key) {
        //forEach
        return vm.checkedProductTypes[key];
      });
    }

    // Create/Update
    function saveMeasurementUnit(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      var checkedProductTypes = [];
      for (var key in vm.checkedProductTypes) {
        if (vm.checkedProductTypes[key]) {
          // add only true values to array
          checkedProductTypes.push(key);
        }
      }

      vm.item.product_types = checkedProductTypes;

      vm.item.symbol = vm.item.is_a_service ? 'Os' : 'Otros';

      // console.log(vm.item); return false;

      vm.sendingForm = true;
      MeasurementUnitService.saveMeasurementUnit(vm.item, vm.defaultLanguage).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // success
          // setItemOptions(response);
          vm.onMeasurementUnitSaved({ item: response });
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onMeasurementUnitCanceled();
    }
  }
})();
